/* eslint-disable no-eval */
// import apiMocker from '@/libs/apiMocker.js'
import http from '@/libs/http.js'
import moment from 'moment'
import Utils from '@/utils'
import _ from 'lodash'
import { MuiltExporter as ExcelExporter } from '@/libs/excelfile'
export function ListMonthCustomer (queryModel) {
  return http.get('crm/statistic/PeriodCustomer', { params: queryModel })
}

export function QueryCustomerPercent (queryModel) {
  return http.get('crm/statistic/CustomerPercent', { params: queryModel })
}

export function QueryTopCustomer (queryModel) {
  return http.get('crm/statistic/CustomerTop', { params: queryModel }).then(resp => {
    return resp.map(i => ({
      id: i.id,
      name: i.name,
      partAmount: i.partAmount,
      partOrder: Utils.DecimalDot2(i.partAmount - i.partReturn),
      service: Utils.DecimalDot2(i.serviceAmount),
      orderCount: i.orderTimes
    }))
  })
}

export const brandGroupDict = {
  '宝马系': '宝马、MINI',
  '奔驰系': '奔驰、SMART、迈巴赫',
  '路虎系': '捷豹、路虎',
  '大众系': '奥迪、大众等',
  '通用系': '雪佛兰、凯迪拉克等',
  '其他': '差价单等'
}

const codeGroupDict = [
  { seriesName: '宝马系', name: 'bmw', brands: [ 'bmw', 'mini' ], filterFunc: (brandCode) => { return ~[ 'bmw', 'mini' ].indexOf(brandCode) } },
  { seriesName: '奔驰系', name: 'benz', brands: [ 'benz', 'smart', 'maybach' ], filterFunc: (brandCode) => { return ~[ 'benz', 'smart', 'maybach' ].indexOf(brandCode) } },
  { seriesName: '捷豹路虎', name: 'jaguar', brands: [ 'landrover', 'jaguar' ], filterFunc: (brandCode) => { return ~[ 'landrover', 'jaguar' ].indexOf(brandCode) } },
  { seriesName: '大众系', name: 'audi', brands: [ 'audi', 'vw', 'porsche', 'skoda' ], filterFunc: (brandCode) => { return ~[ 'audi', 'vw', 'porsche', 'skoda' ].indexOf(brandCode) } },
  { seriesName: '通用系', name: 'gmw', brands: ['chevrolet', 'cadillac', 'buick'], filterFunc: (brandCode) => { return ~['chevrolet', 'cadillac', 'buick'].indexOf(brandCode) } },
  { seriesName: '其他', name: 'other', brands: undefined, filterFunc: (brandCode) => { return ['chevrolet', 'cadillac', 'buick', 'audi', 'vw', 'porsche', 'skoda', 'landrover', 'jaguar', 'benz', 'smart', 'maybach', 'bmw', 'mini'].indexOf(brandCode) === -1 } }
]

export function LoadOrderStatistic (queryModel) {
  return http.get('crm/statistic/BrandPeriod', { params: queryModel }).then((resp) => {
    const result = []
    if (queryModel.dayPeriod) {
      let startDay = moment().add(-1, 'M')
      if (queryModel.startDay) {
        startDay = moment(queryModel.startDay)
      }
      for (let day = startDay; day.isBefore(moment(queryModel.endDay)); day = day.add(1, 'd')) {
        const peroidStr = day.format('YYYY-MM-DD')
        const periodData = {
          date: day.format('MM/DD')
        }
        codeGroupDict.forEach((b) => {
          const pd = resp.filter(t => t.period === peroidStr && b.filterFunc(t.brandCode))
          let amountAll = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amount || 0), 0))
          let amountReturn = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amountReturn || 0), 0))
          let countAll = pd.reduce((p, c) => p + c.orderCount, 0)
          let countReturnAll = pd.reduce((p, c) => p + c.orderReturnCount, 0)
          periodData[b.name] = amountAll
          periodData[b.name + 'Return'] = amountReturn
          periodData[b.name + 'Count'] = countAll
          periodData[b.name + 'CountReturn'] = countReturnAll
          periodData[b.name + 'All'] = amountAll
          periodData[b.name + 'ReturnAll'] = amountReturn
          periodData[b.name + 'CountAll'] = countAll
          periodData[b.name + 'CountReturnAll'] = countReturnAll
          periodData[b.name + 'Ji'] = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amountJi || 0), 0))
          periodData[b.name + 'Tax'] = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amountTax || 0), 0))
          periodData[b.name + 'CountJi'] = pd.reduce((p, c) => p + c.orderCountJi, 0)
          periodData[b.name + 'CountTax'] = pd.reduce((p, c) => p + c.orderCountTax, 0)
          periodData[b.name + 'TaxReturn'] = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amountReturnTax || 0), 0))
          periodData[b.name + 'JiReturn'] = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amountReturnJi || 0), 0))
          periodData[b.name + 'CountReturnJi'] = pd.reduce((p, c) => p + c.orderReturnCountJi, 0)
          periodData[b.name + 'CountReturnTax'] = pd.reduce((p, c) => p + c.orderReturnCountTax, 0)
        })
        result.push(periodData)
      }
    } else {
      var t = moment().add(-1, 'Y')
      let startDay = moment(new Date(t.year(), t.month(), 1))
      if (queryModel.startDay) {
        startDay = moment(queryModel.startDay)
      }
      for (let mon = startDay; mon.isBefore(moment(queryModel.endDay)); mon = mon.add(1, 'M')) {
        const peroidStr = mon.format('YYYY-MM')
        const periodData = {
          date: mon.format('YYYY/MM')
        }
        codeGroupDict.forEach((b) => {
          const pd = resp.filter(t => t.period === peroidStr && b.filterFunc(t.brandCode))
          let amountAll = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amount || 0), 0))
          let amountReturn = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amountReturn || 0), 0))
          let countAll = pd.reduce((p, c) => p + c.orderCount, 0)
          let countReturnAll = pd.reduce((p, c) => p + c.orderReturnCount, 0)
          periodData[b.name] = amountAll
          periodData[b.name + 'Return'] = amountReturn
          periodData[b.name + 'Count'] = countAll
          periodData[b.name + 'CountReturn'] = countReturnAll
          periodData[b.name + 'All'] = amountAll
          periodData[b.name + 'ReturnAll'] = amountReturn
          periodData[b.name + 'CountAll'] = countAll
          periodData[b.name + 'CountReturnAll'] = countReturnAll
          periodData[b.name + 'Ji'] = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amountJi || 0), 0))
          periodData[b.name + 'Tax'] = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amountTax || 0), 0))
          periodData[b.name + 'CountJi'] = pd.reduce((p, c) => p + c.orderCountJi, 0)
          periodData[b.name + 'CountTax'] = pd.reduce((p, c) => p + c.orderCountTax, 0)
          periodData[b.name + 'TaxReturn'] = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amountReturnTax || 0), 0))
          periodData[b.name + 'JiReturn'] = Utils.DecimalDot2(pd.reduce((p, c) => p + (c.amountReturnJi || 0), 0))
          periodData[b.name + 'CountReturnJi'] = pd.reduce((p, c) => p + c.orderReturnCountJi, 0)
          periodData[b.name + 'CountReturnTax'] = pd.reduce((p, c) => p + c.orderReturnCountTax, 0)
        })
        result.push(periodData)
      }
    }
    return result
  })
}

export function LoadBrandStatistic (queryModel) {
  return http.get('crm/statistic/brandpercent', { params: queryModel }).then((resp) => {
    return codeGroupDict.map(b => {
      const subBrands = resp.filter(r => b.filterFunc(r.brandCode))
      const amount = subBrands.reduce((p, c) => p + c.amountPay, 0)
      const amountReturn = subBrands.reduce((p, c) => p + c.amountReturn, 0)
      return {
        name: b.seriesName,
        amount: Utils.DecimalDot2(amount),
        amountReturn: Utils.DecimalDot2(amountReturn),
        value: Utils.DecimalDot2(amount - amountReturn)
      }
    })
  })
}

export function LoadSellDiscount (queryModel) {
  return http.get('crm/statistic/BrandDiscount', { params: queryModel }).then((resp) => {
    const result = codeGroupDict.map(b => {
      const taxedData = resp.filter(r => b.filterFunc(r.brandCode) && r.taxed)
      const untaxedData = resp.filter(r => b.filterFunc(r.brandCode) && !r.taxed)
      const taxedAmount4s = taxedData.reduce((p, c) => p + c.amount4s, 0)
      const taxedAmountDiscount = taxedData.reduce((p, c) => p + c.amountDiscount, 0)
      const untaxedAmount4s = untaxedData.reduce((p, c) => p + c.amount4s, 0)
      const untaxedAmountDiscount = untaxedData.reduce((p, c) => p + c.amountDiscount, 0)
      return {
        name: b.seriesName,
        taxedAmount4s: Utils.DecimalDot2(taxedAmount4s),
        taxedAmountDiscount: Utils.DecimalDot2(taxedAmountDiscount),
        untaxedAmount4s: Utils.DecimalDot2(untaxedAmount4s),
        untaxedAmountDiscount: Utils.DecimalDot2(untaxedAmountDiscount),
        taxed: taxedAmount4s > 0 ? Utils.DecimalDot2(taxedAmountDiscount / taxedAmount4s) : 0,
        untaxed: untaxedAmount4s > 0 ? Utils.DecimalDot2(untaxedAmountDiscount / untaxedAmount4s) : 0,
        labelName: brandGroupDict[b.name]
      }
    })
    return result.filter(t => t.name !== '其他')
  })
}

export function LoadBrandStatisticByArea (queryModel) {
  return http.get('crm/statistic/brandarea', { params: queryModel }).then(resp => {
    let allProvince = _.groupBy(resp, e => { return e.province })
    const showResult = []
    for (let key in allProvince) {
      let outObj = {}
      outObj.name = key
      let showValue = []
      codeGroupDict.forEach(e => {
        let obj = {}
        let brandByCode = []
        allProvince[key].forEach(i => {
          if (e.filterFunc(i.brandCode)) {
            brandByCode.push(i)
          }
        })
        obj.brands = e.name
        obj.name = e.seriesName
        obj.amount = brandByCode.reduce((p, c) => p + c.amount, 0)
        obj.amountJi = brandByCode.reduce((p, c) => p + c.amountJi, 0)
        obj.amountReturn = brandByCode.reduce((p, c) => p + c.amountReturn, 0)
        obj.amountReturnJi = brandByCode.reduce((p, c) => p + c.amountReturnJi, 0)
        obj.amountReturnTax = brandByCode.reduce((p, c) => p + c.amountReturnTax, 0)
        obj.amountTax = brandByCode.reduce((p, c) => p + c.amountTax, 0)
        obj.orderCount = brandByCode.reduce((p, c) => p + c.orderCount, 0)
        obj.orderCountJi = brandByCode.reduce((p, c) => p + c.orderCountJi, 0)
        obj.orderCountTax = brandByCode.reduce((p, c) => p + c.orderCountTax, 0)
        obj.orderReturnCountJi = brandByCode.reduce((p, c) => p + c.orderReturnCountJi, 0)
        obj.orderReturnCount = brandByCode.reduce((p, c) => p + c.orderReturnCount, 0)
        obj.orderReturnCountTax = brandByCode.reduce((p, c) => p + c.orderReturnCountTax, 0)
        showValue.push(obj)
      })
      outObj.showValue = showValue
      outObj.value = outObj.showValue.reduce((p, c) => p + c.amount, 0)
      showResult.push(outObj)
    }
    return showResult
  })
}

export function LoadSummaryStatistic (queryModel) {
  return http.get('crm/statistic/summary', { params: queryModel }).then((resp) => {
    return {
      customerAll: (resp.customerAll || 0).toLocaleString(),
      customerMonth: (resp.customerMonth || 0).toLocaleString(),
      partAll: (resp.partAll || 0).toLocaleString(),
      partMonth: (resp.partMonth || 0).toLocaleString(),
      serviceAll: (resp.serviceAll || 0).toLocaleString(),
      serviceMonth: (resp.serviceMonth || 0).toLocaleString(),
      partReturnAll: (resp.partReturnAll || 0).toLocaleString(),
      partReturnMonth: (resp.partReturnMonth || 0).toLocaleString()
    }
  })
}

export function CostumerConsumer (queryModel, brandsData) {
  let detailSheetMeta = {
    mergeInfo: [],
    sheetName: '明细',
    data: [],
    options: {
      '!cols': [{ wpx: 60 }, { wpx: 60 }, { wpx: 140 }],
      headerRows: 2
    }
  }
  return new Promise((resolve, reject) => {
    http.post('crm/statistic/customerconsumer', queryModel).then((resp) => {
      let startDate = moment(resp[resp.length - 1].period + '-01')
      let endDate = moment(resp[0].period + '-01')
      const periods = []
      let summarySheetMetas = []
      let colIndex = 3
      const header1 = [null, null, null]
      const header2 = ['省', '市', '客户名称']
      for (;endDate.isSameOrAfter(startDate); endDate = endDate.add(-1, 'M')) {
        let period = endDate.format('YYYY-MM')
        periods.push(period)
        header1.push(period, null, null, null, null)
        detailSheetMeta.mergeInfo.push({ s: { r: 0, c: colIndex }, e: { r: 0, c: colIndex + 4 } })
        header2.push('净销售额', '订单金额', '订单笔数', '退款金额', '退款笔数')
        detailSheetMeta.options['!cols'].push({ wpx: 80 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 })
        colIndex += 5
      }
      detailSheetMeta.data.push(header1, header2)
      const buyerIdGrp = _.groupBy(resp, o => o.buyerId)
      for (let buyer in buyerIdGrp) {
        let buyerData = []
        const { province, city, companyName } = buyerIdGrp[buyer][0]
        buyerData.push(province, city, companyName)
        for (let period of periods) {
          const buyerPeriod = buyerIdGrp[buyer].find(t => t.period === period)
          if (buyerPeriod) {
            const { amountRemain, amount, orderCount, amountReturn, returnCount } = buyerPeriod
            buyerData.push(amountRemain, amount, orderCount, amountReturn, returnCount)
          } else {
            buyerData.push(0.00, 0.00, 0.00, 0.00, 0.00)
          }
        }
        detailSheetMeta.data.push(buyerData)
      }
      const provinceGrp = _.groupBy(resp, o => o.province)
      const totalMeta = {
        mergeInfo: [],
        sheetName: '区域总览',
        data: [['省份', '月份', '客户数', '净销售额', '订单金额', '订单笔数', '退款金额', '退款笔数']],
        options: {
          '!cols': [{ wpx: 60 }, { wpx: 60 }, { wpx: 60 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 }]
        },
        totalAmount: 0
      }
      for (let province in provinceGrp) {
        const meta = {
          mergeInfo: [],
          sheetName: '',
          data: [['月份', '客户数', '净销售额', '订单金额', '订单笔数', '退款金额', '退款笔数']],
          options: {
            '!cols': [{ wpx: 60 }, { wpx: 60 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 }]
          },
          totalAmount: 0
        }
        meta.sheetName = `${province}概况`
        for (let period of periods) {
          let rowData = [period]
          let totalRowData = [province, period]
          const provincePeriods = provinceGrp[province].filter(t => t.period === period)
          if (provincePeriods && provincePeriods.length) {
            const buyerCount = _.uniqBy(provincePeriods, 'buyerId').length
            const amountRemain = _.sumBy(provincePeriods, o => o.amountRemain)
            const amount = _.sumBy(provincePeriods, o => o.amount)
            const orderCount = _.sumBy(provincePeriods, o => o.orderCount)
            const amountReturn = _.sumBy(provincePeriods, o => o.amountReturn)
            const returnCount = _.sumBy(provincePeriods, o => o.returnCount)
            rowData.push(buyerCount, amountRemain, amount, orderCount, amountReturn, returnCount)
            totalRowData.push(buyerCount, amountRemain, amount, orderCount, amountReturn, returnCount)
            meta.totalAmount += amountRemain
            totalMeta.totalAmount += amountRemain
          } else {
            rowData.push(0, 0.00, 0.00, 0.00, 0.00, 0.00)
            totalRowData.push(0, 0.00, 0.00, 0.00, 0.00, 0.00)
          }
          meta.data.push(rowData)
          totalMeta.data.push(totalRowData)
        }
        summarySheetMetas.push(meta)
      }
      summarySheetMetas.push(totalMeta)
      summarySheetMetas.sort((b, a) => a.totalAmount - b.totalAmount)
      ExcelExporter(
        [brandsData, detailSheetMeta, ...summarySheetMetas],
        `兆配云按地区月度统计_${moment().format('YYYYMMDDHHmmss')}.xlsx`
      ).then(() => {
        resolve()
      }).catch(() => {
        reject(new Error('导出文件失败'))
      })
    }).catch(() => {
      reject(new Error('下载数据失败'))
    })
  })
}
